<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">Patient Admission Request</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <!-- <loader /> -->
        <!-- Patient quick info -->
        <div class="profile-header">
          <div>
            <h2>
              {{ patient }}
            </h2>
            <p>OPD : {{ opd }}</p>
          </div>
        </div>

        <!-- Admission Form -->
        <form @submit.prevent="submitAdmission">
          <div class="form-group">
            <label for="admission-date">Admission Date</label>
            <input
              type="date"
              id="admission-date"
              v-model="form.admission_date"
              required
            />
          </div>

          <div class="form-group">
            <label for="ward">Ward/Room</label>
            <!-- <input
              type="text"
              id="ward"
              v-model="form.ward"
              placeholder="Enter ward or room"
              required
            /> -->
            <select
              class="form-select"
              v-model="form.ward"
              aria-label="Select Ward"
            >
              <option disabled value="">--Select--</option>
              <option v-for="ward in wards" :key="ward.id" :value="ward.id">
                {{ ward.ward_name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="reason">Reason for Admission</label>
            <textarea
              id="reason"
              v-model="form.reason"
              rows="3"
              placeholder="Enter reason"
              required
            ></textarea>
          </div>

          <div class="form-group">
            <label for="notes">Additional Notes</label>
            <textarea
              id="notes"
              v-model="form.notes"
              rows="2"
              placeholder="Optional notes"
            ></textarea>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary">
              Submit Request
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import loader from "../../special_clinics/dialysis/loader.vue";
export default {
  name: "AdmissionModal",
  props: {
    visit_id: {
      type: [String, Number],
      required: true, // expect {id, name, photo(optional)}
    },
  },
  data() {
    return {
      wards: [],
      patient: "",
      patient_id: "",
      opd: "",
      loading: false,
      form: {
        admission_date: this.getTodayDate(),
        ward: "",
        reason: "",
        notes: "",
      },
    };
  },
  components: {
    loader,
  },
  methods: {
    getTodayDate() {
      const today = new Date();
      return today.toISOString().slice(0, 10); // YYYY-MM-DD
    },
    closeModal() {
      this.$emit("close-request-admission-modal");
    },
    async submitAdmission() {
      this.loading = true;

      const res = await generalApiRequest(
        "inpatients/request_admission",
        "POST",
        { ...this.form, patient_id: this.patient_id, visit_id: this.visit_id },
        1
      );
      this.loading = false;
      if (res) {
        this.closeModal();
      } else {
        alert("error requesting Admission");
        console.log("error in api call");
      }
    },
    async get_visit() {
      this.loading = true;
      const res = await generalApiRequest(
        "getVisitById/" + this.visit_id,
        "GET",
        {},
        1
      );
      this.patient = res.name;
      this.patient_id = res.patient_id;
      this.opd = res.opd;

      //   wards
      const wards = await generalApiRequest(
        "inpatient/getCompanyWards",
        "GET",
        {},
        1
      );
      this.wards = wards;
      this.loading = false;
    },
  },
  mounted() {
    this.get_visit();
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
.form-group label {
  font-weight: bold;
  margin-bottom: 0.25rem;
}
.form-group input,
.form-group textarea {
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.modal-footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
}
.btn-primary {
  background: #007bff;
  border: none;
  color: white;
}
.btn-secondary {
  background: #6c757d;
  border: none;
  color: white;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
